export interface TaxCode {
  id: number;
  name: string;
  rate_percent: string;
  is_taxable: boolean;
  active: boolean;
  created_at: string;
}

export interface CreateTaxCodeData {
  name: string;
  rate_percent: number;
  is_taxable?: boolean;
  active?: boolean;
}

export interface UpdateTaxCodeData {
  name?: string;
  rate_percent?: number;
  is_taxable?: boolean;
  active?: boolean;
}

export interface TaxCodesListParams {
  active?: boolean;
  is_taxable?: boolean;
}

export interface TaxCodeResponse {
  data: TaxCode;
}

export interface TaxCodesListResponse {
  data: TaxCode[];
}

export const formatTaxCodeLabel = (code: TaxCode): string => {
  const rate = parseFloat(code.rate_percent);
  if (!code.is_taxable) {
    return `${code.name} (exempt)`;
  }
  return `${code.name} (${Number.isFinite(rate) ? rate : code.rate_percent}%)`;
};
